export default {
	you:'Ja',
	is_calling_accept:'Agent uspotavlja poziv. Prihvati',
	chat_initialized:'Razgovor aktivan',
	initializing_chat:'Pokrećem razgovor',
	chat:'Chat',
	welcome: 'Dobrodošli',
	start_chat:'Pokreni razgovor',
	start_chat_video: 'Započnite video poziv',
	start_chat_video_id: 'Započnite video ID',
	name:'Ime i prezime',
	email:'E-mail',
	telephone:'Kontakt telefon',
	placeholder_name:'Vaše ime i prezime',
	placeholder_email:'primjer@email.com',
	placeholder_telephone:'+387 XX XXX XXX',
	placeholder_taxNumber:'XXXXXXXX',
	topic:'Tema',
	topic_nlb:'Naručite/promijenite proizvod',
	select_topic_nlb:'Odaberite iz izbornika',
	cancel:'Odustani',
	send:'Pošalji',
    sent: 'Poslano',
	minimize:'Smanji',
	end_chat:'Završi',
  close: 'Zatvori',
    entered_chat: 'Agent ušao u razgovor',
    left_chat: 'Agent napustio razgovor',
    HANDLED:'Razgovor završen',
    MISSED:'Razgovor završen',
	MISSED_QUEUE:'Trenutno nismo u mogućnosti obraditi Vaš zahtjev, molimo pokušajte kasnije!',
	MISSED_PROCESSING:'Trenutno nismo u mogućnosti obraditi Vaš zahtjev. Prvi slobodni agent kontaktirat će Vas u što skorijem roku!',
	audio_input:'Mikrofon',
	audio_output:'Reprodukcija zvuka',
	video_input: 'Kamera',
    invite_text: 'Ovo je jednokratna poveznica za razgovor. Jednom kada se pokrene razgovor, neće više biti moguće iskoristiti ovu poveznicu ponovno',
	type_message: 'Napiši poruku',
	survey_heading: 'Hvala',
	survey_subheading: 'Vaše mišljenje nam puno znači, stoga Vas molimo da ispunite kratku anketu.',
	agree_with: 'Slažem se sa ',
	general_terms: 'opštim uslovima',
	con_satisfaction: 'Jeste li zadovoljni razgovorom?',
	get_answers: 'Jeste li dobili odgovore na svoja pitanja?',
	fully: 'U cijelosti',
	partially: 'Djelomično',
	no_answer: 'Nisam dobio odgovor',
	recommend: 'Koliko je vjerojatno da biste nas preporučili prijateljima ili poznanicima?',
	device_settings: 'Postavke uređaja',
	show: 'Da, želim',
	not: 'Ne, hvala',
	start_survey: 'Cijenimo tvoje mišljenje. Da li želiš popuniti anketu?',
	call_start: 'Poziv pokrenut',
	call_end: 'Poziv završen',
	required_message: 'Ovo polje je obavezno',
	required_tel_message: 'Ovo polje je obavezno - primjer +YYY XX XXX XXX',
	tel_format: 'npr. 091 555 1234',
	incorrect_email_format: 'Netočan format - primjer xy@acme.com',
	topic_1: 'Krediti/Limiti',
	topic_2: 'PIN/Kartice/NLB Pay',
	topic_3: 'Plaćanja/Paketi',
	topic_4: 'NLB Klik',
	topic_5: 'NLB Proklik/Klikpro',
	topic_6: 'Ostale informacije',
	survey_field_1_label_info: 'Koliko ste zadovoljni komunikacijom i suradnjom s odgovornim osobljem?',
	survey_field_2_label_info: 'Jeste li dobili odgovore na vaša pitanja u cijelosti?',
	survey_field_3_label_info: 'Koliko je vjerojatno da ćete preporučiti našu uslugu prijatelju ili znancu?',
	bubble_txt1: 'Zanima Vas naša ponuda?',
	bubble_txt2: 'Razgovarajte s agentom uživo.',
	incoming_video_call: 'Dolazni video poziv',
	incoming_call: 'Dolazni poziv',
	invite_end_message: 'Zahvaljujemo Vam na kontaktiranju naše korisničke službe!',
	invite_end_message2: 'Nadamo se da smo vam danas uspjeli pomoći. Ako trebate bilo kakvu dodatnu pomoć, ne ustručavajte se kontaktirati nas. Želimo Vam ugodan dan!',
	expired_message: 'Chat je istekao',
	microphone_not_detected: 'Mikrofon nije detektiran',
	camera_or_microphone_not_detected: 'Kamera ili mikrofon nije detektiran',
	system_default_speaker_device: 'Zadani uređaj za reprodukciju zvuka',
	instructions_enable_media_setsinkid: 'Kliknite ovdje za upute kako biste dobili popis uređaja za reprodukciju zvuka',
	welcome_chat: 'Upoznajmo se!',
	welcome_chat_video: 'Upoznajmo se!',
	welcome_chat_video_id: 'Upoznajmo se!',
	close_settings: 'Zatvori postavke',
	agent: 'Agent',
	enter_data: 'Molimo unesite svoje podatke',
	survey: 'Anketa',
	open_survey: 'Otvori anketu',
	submitted: 'Podneseno',
	chatbot: 'Chatbot',
	general_error: 'Pojavila se greška. Molimo pokušajte ponovo',
	file_max_size_exceeded: 'Dokument premašuje dozvoljenu veličinu. Dozvoljena veličina: ',
	file_extension_not_allowed: "Nepodržan format dokumenta. Podržani su: ",
	uploaded_file_message: 'Nova datoteka je učitana',
	next: 'Dalje',
	submit: "Nastavi",
	scan_document: "Skeniranje dokumenta",
	start: "Započni",
	finish_on_call_end: 'Razgovor je završen'
}